import Head from 'next/head';
import React from 'react';

import { DEFAULT_PAGE_HEAD } from './constants';

import type { ReactElement } from 'react';

export const PageHead = (): ReactElement => (
  <Head>
    <title>{DEFAULT_PAGE_HEAD}</title>
  </Head>
);
